import SyncListItem from './SyncListItem'

export default SyncListItem
